<div class="footer">
    <div class="card clearfix">
        <span class="footer-text-left">PrimeNG Barcelona for Angular</span>
        <span class="footer-text-right">
            <span>All Rights Reserved</span>
        </span>
    </div>
</div>